module.exports = __webpack_public_path__ + "img/scan.696e218d.jpg";